export const LOGO_DHL = 'LOGO_DHL'
export const LOGO_HERMES = 'LOGO_HERMES'
export const LOGO_POST = 'LOGO_POST'
export const LOGO_COLISSIMO = 'LOGO_COLISSIMO'
export const LOGO_POINTRELAIS = 'LOGO_POINTRELAIS'
export const LOGO_BRT = 'LOGO_BRT'
